/*
CopyRight: 2019 - ArTiBulles
Created on : 02-July-2019
Author: Arnaud Jaspard - Arnaud.jaspard@artibulles.com
Version: 1.0
Description: Creating React Icons with Frames
License : MIT
*/
import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
var name = 'ZoomIn';
var keywords = ['Search'];
var category = 'navigation';
var meta = {
  keywords: keywords,
  name: name,
  category: category,
  "class": "Icon_".concat(name)
};
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
  id: "zoom",
  transform: "translate(2.000000, 2.000000)",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54.9245283,36.9245283 L45.0754717,36.9245283 L45.0754717,27.0754717 C45.0754717,24.81798 43.2574917,23 41,23 C38.7425083,23 36.9245283,24.81798 36.9245283,27.0754717 L36.9245283,36.9245283 L27.0754717,36.9245283 C24.81798,36.9245283 23,38.7425083 23,41 C23,43.2574917 24.81798,45.0754717 27.0754717,45.0754717 L36.9245283,45.0754717 L36.9245283,54.9245283 C36.9245283,57.18202 38.7425083,59 41,59 C43.2574917,59 45.0754717,57.18202 45.0754717,54.9245283 L45.0754717,45.0754717 L54.9245283,45.0754717 C57.18202,45.0754717 59,43.2574917 59,41 C59,38.7425083 57.1620422,36.9245283 54.9245283,36.9245283 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.985072,74.0413192 C22.7847221,74.0413192 8.03244719,59.2840777 8.03244719,41.0533898 C8.03244719,22.8227019 22.7847221,8.06546043 40.985072,8.06546043 C59.1854218,8.06546043 73.9181054,22.8423259 73.9181054,41.0533898 C73.9181054,59.2644537 59.1658305,74.0413192 40.985072,74.0413192 Z M94.8220595,89.3480324 L72.6250774,67.1140503 C78.4437037,60.0297894 81.9505526,50.9438814 81.9505526,41.0533898 C81.9505526,18.3876799 63.6130634,0 40.9654806,0 C18.3178978,0 0,18.3876799 0,41.0533898 C0,63.7190998 18.3374892,82.1067796 40.985072,82.1067796 C50.8591046,82.1067796 59.9103012,78.6137092 66.982773,72.7853838 L89.1797551,95.0193659 C90.1985045,96.0594374 93.3135267,96.5696612 94.8416508,95.0193659 C96.3893662,93.4494466 96.3893662,90.9179517 94.8220595,89.3480324 L94.8220595,89.3480324 Z",
  id: "Shape"
}))), meta);